<template lang="pug">
v-flex(xs12 :class="{'pl-3': $vuetify.breakpoint.lgAndUp}").fonte.pa-0.ma-0
  v-card.payment-method-card(flat)
    div.pa-4
      div.expande-horizontal.align-center.mb-4
        v-avatar(size="34" color="#eef2ff").mr-3
          v-icon(color="#3158d3") mdi-wallet-outline
        div
          div.method-title Metodo de pagamento
          div.method-subtitle Escolha como deseja finalizar sua assinatura

      div.expande-horizontal.wrap
        v-flex(xs12 md6).pa-1
          div.method-option.clickable(
            :class="{ 'method-option-selected': get_checkout.method === 'card' }"
            @click="selectMethod('card')"
          )
            v-icon(size="22" :color="get_checkout.method === 'card' ? '#3158d3' : '#64748b'") mdi-credit-card-outline
            div.ml-3
              div.option-title Cartao de credito
              div.option-subtitle Confirmacao imediata

        v-flex(xs12 md6).pa-1
          div.method-option.clickable(
            :class="{ 'method-option-selected': get_checkout.method === 'pix' }"
            @click="selectMethod('pix')"
          )
            v-icon(size="22" :color="get_checkout.method === 'pix' ? '#059669' : '#64748b'") mdi-qrcode-scan
            div.ml-3
              div.option-title Pix
              div.option-subtitle Aprovacao apos pagamento
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["get_checkout"])
  },
  methods: {
    selectMethod(method) {
      this.get_checkout.method = method;
      this.$vuetify.goTo(2300);
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
.payment-method-card {
  margin-top: 16px;
  border: 1px solid #e9ecf5;
  border-radius: 14px;
  background: #fff;
}

.method-title {
  font-size: 17px;
  font-weight: 700;
  color: #1f2937;
}

.method-subtitle {
  font-size: 13px;
  color: #6b7280;
}

.method-option {
  display: flex;
  align-items: center;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  transition: 0.2s ease;
}

.method-option:hover {
  transform: translateY(-1px);
  border-color: #cbd5e1;
}

.method-option-selected {
  background: #f8fbff;
  border-color: #93c5fd;
  box-shadow: 0 8px 18px rgba(59, 130, 246, 0.12);
}

.option-title {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.option-subtitle {
  font-size: 12px;
  color: #64748b;
}

.clickable {
  cursor: pointer;
}
</style>
